import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { PaginationSizings } from "../../../../Constant";
import { DynamicPaginationSizing } from "./DynamicPaginationSizing";
import { StaticPaginationSizing } from "./StaticPaginationSizing";
import { SIZING_PAGINATIONS } from "../../../../Data/Bonus Ui/Paginations";

const PaginationSizing = () => {
  return (
    <Col xl="6">
      <Card className="height-equal">
        <CommonCardHeader title={PaginationSizings} span={SIZING_PAGINATIONS} />
        <CardBody className="pb-4">
          <StaticPaginationSizing />
          <DynamicPaginationSizing />
        </CardBody>
      </Card>
    </Col>
  );
};

export default PaginationSizing;
